// NOTE: Migrating from @shopify/polaris React components to Polaris Web Components
// Removed: BlockStack, Card, Text, InlineStack, ButtonGroup, Box, Button, Badge (migrated to s-stack, s-section, s-text, s-button-group, s-box, s-button, s-badge)
import React from 'react';

export const IntegrationCard = ({ title, description, featuredText, button, image }) => {
    return (
        <div
            style={{
                width: "18rem",
                borderRadius: ".75rem",
                position: "relative",
                zIndex: "0",
            }}
        >
            <s-section>
                <s-stack gap="large">
                    <s-stack gap="small" align="start">
                        <img
                            src={image.src}
                            alt={image.alt}
                            width={image.width}
                            height={image.height}
                            style={image.style}
                        />
                        <s-text as="h3" variant="headingSm" alignment="center">
                            {title}
                        </s-text>

                        {description ? (
                            <s-text as="p" variant="bodySm" tone="subdued" alignment="center">
                                {description}
                            </s-text>
                        ) : null}
                        {/* <s-badge size="large" tone="success" alignment="center">
                            {featuredText > 1 ? `${featuredText} Configs` : `${featuredText} Config`}
                        </s-badge> */}

                        <s-stack direction="inline" blockAlign="end" gap="extra-small" align="center">
                            <s-text as="h2" variant="heading2xl">
                                {featuredText}
                            </s-text>
                            <s-box paddingBlockEnd="200">
                                <s-text variant="bodySm">{featuredText > 1 ? `Configs` : `Config`}</s-text>
                            </s-box>
                        </s-stack>
                    </s-stack>

                    <s-box paddingBlockStart="200" paddingBlockEnd="200">
                        <s-button-group variant="segmented" fullWidth>
                            <s-button {...button.props}>{button.content}</s-button>
                        </s-button-group>
                    </s-box>
                </s-stack>
            </s-section>
        </div>
    );
};
